import { MultiPurposeParagraph } from "@/components/Atoms/Paragraph";
import { useTranslation } from "next-i18next";
import { Title } from "@/components/Atoms/Title";
import VideoPlayerBlock from "@/components/Atoms/Video";

interface Props {
  data: any;
  config: any;
  layout?: string;
}

export default function DirectionsBlock({ data, config, layout }: Props) {
  const { t } = useTranslation();

  return (
    <div className=" flex flex-col gap-4 pb-12">
      <Title
        tag={"h3"}
        className="titleRecipeSection"
        data={t("preparation")}
        color={config?.headlineTextColor.color}
      />
      {data.addPrepVideo && data.prepVideo?.video?.url && (
        <VideoPlayerBlock
          videoUrl={data.prepVideo.video.url}
          loop={data.prepVideo.loop}
          autoplay={data.prepVideo.autoplay}
          textColor={"#fff"}
        />
      )}
      {data.recipeInstructions.map((main: any, i: number) => (
        <ol key={i} className="flex flex-col gap-4 list-none pl-0">
          {main.step.map((step: any, index: number) => (
            <li
              key={index}
              className="flex flex-row items-center gap-3"
            >
              <span
                className="titleRecipeSection shrink-0"
                style={{ color: config?.headlineTextColor?.color?.hex }}
              >
                {index + 1}.
              </span>
              <div className="min-w-0 flex-1">
                <MultiPurposeParagraph
                  data={step.text}
                  color={config?.headlineTextColor.color}
                />
              </div>
            </li>
          ))}
        </ol>
      ))}
      {data.tip && (
        <div
          style={{ backgroundColor: config?.cardBackgroundColor?.color.hex }}
          className={`${
            layout == "cocktail" ? "rounded-xl overflow-hidden" : ""
          } p-4 text-center mt-4`}
        >
          <MultiPurposeParagraph
            data={t("tips")}
            color={config?.highlightTextColor.color}
          />
          <MultiPurposeParagraph
            data={data.tip}
            color={config?.headlineTextColor.color}
          />
        </div>
      )}
    </div>
  );
}
